import { Observable } from 'rxjs';
import { AuthSession, CodeRequest } from '../models/auth/user.model';

/** Первый вход по SMS-коду и есть регистрация — отдельного контракта регистрации нет. */
export abstract class AuthApi {
  abstract requestCode(phone: string): Observable<CodeRequest>;
  abstract confirmCode(phone: string, code: string): Observable<AuthSession>;
  /** `null` — Telegram-аккаунт ещё не привязан: это не ошибка, клиент входит по SMS. */
  abstract telegramLogin(initData: string): Observable<AuthSession | null>;
  /** Идемпотентна: после каждого SMS-входа внутри Telegram её можно звать снова. */
  abstract linkTelegram(initData: string): Observable<void>;
  /** Возвращает НОВУЮ пару токенов: старый refresh умирает сразу, сохранять обязательно оба. */
  abstract refresh(refreshToken: string): Observable<{ token: string; refreshToken: string }>;
  /** Ошибку выхода потребитель глотает: локальную сессию чистим в любом случае. */
  abstract logout(unlinkTelegram: boolean): Observable<void>;
}
